import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point.js';
import VectorSource from 'ol/source/Vector';
import TileWMS from 'ol/source/TileWMS';
import {fromLonLat} from 'ol/proj.js';
import LayerGroup from 'ol/layer/Group';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {defaults as defaultControls, FullScreen} from 'ol/control';
import {Circle as CircleStyle, Fill, Stroke, Style, RegularShape} from 'ol/style';

/*
*	This Class creates basic OL map and creates base64 image from it.
*/
export class OLmap2img{
	constructor(map_type,map_container,map_width,map_height,coordinates){
		this.map_type = map_type;
		this.map_container = map_container;			//id of DOM element - container for div elements
		this.map_size = [map_width,map_height];
		this.coordinates = coordinates;
		this.zoom = {"OSM":15, "DOF":17};
		this.images_container = [];
		this.olMap = [];
		this.mapDomId = [];
		
		var that = this;
	}
	
	getPromise(){
		// return result
		const p1 = this.process();
		
		return new Promise(function(resolve, reject) {	
			p1.then(function(result){ 
				resolve(result);
			});
		});
	}
	
	process(){
		//build map
		var that = this;
		
		return new Promise(function(resolve, reject) {
			var promises = [];
			
			for(var i=0;i<that.coordinates.length;i++){
				var map = that.buildMap(that.coordinates[i], i);
				// export image
				promises.push(that.exportImage(map));
			}	
			
			// add map with two points
			if(that.coordinates.length == 2){
				var map2 = that.buildMap2(that.coordinates);
				// export image
				promises.push(that.exportImage(map2));
			}

			var image_promises = Promise.all(promises);

			image_promises.then(function(value) {
					// shrani pridobljen rezultat
					that.images_container = value;
					resolve(that.images_container);	
				});		
		});			
	}
	
	/*
	***	M2 - Export map image
	*/	
	exportImage(map){
		
		var promise = new Promise(function(myResolve, myReject) {
								
			map.once('rendercomplete', function () {
				const mapCanvas = document.createElement('canvas');
				const size = map.getSize();
				mapCanvas.width = size[0];
				mapCanvas.height = size[1];
				const mapContext = mapCanvas.getContext('2d');
				Array.prototype.forEach.call(
				  map.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'),
				  function (canvas) {
					if (canvas.width > 0) {
					  const opacity =
						canvas.parentNode.style.opacity || canvas.style.opacity;
					  mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
					  let matrix;
					  const transform = canvas.style.transform;
					  if (transform) {
						// Get the transform parameters from the style's transform matrix
						matrix = transform
						  .match(/^matrix\(([^\(]*)\)$/)[1]
						  .split(',')
						  .map(Number);
					  } else {
						matrix = [
						  parseFloat(canvas.style.width) / canvas.width,
						  0,
						  0,
						  parseFloat(canvas.style.height) / canvas.height,
						  0,
						  0,
						];
					  }
					  // Apply the transform to the export map context
					  CanvasRenderingContext2D.prototype.setTransform.apply(
						mapContext,
						matrix,
					  );
					  const backgroundColor = canvas.parentNode.style.backgroundColor;
					  if (backgroundColor) {
						mapContext.fillStyle = backgroundColor;
						mapContext.fillRect(0, 0, canvas.width, canvas.height);
					  }
					  mapContext.drawImage(canvas, 0, 0);
					}
				  },
				);
				mapContext.globalAlpha = 1;
				mapContext.setTransform(1, 0, 0, 1, 0, 0);
				
				try{
					var image = mapCanvas.toDataURL("image/png").split(';base64,')[1];
				}catch(error){
					console.log(error);
					var image = 'iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQCAYAAACAvzbMAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpVIqHcyg4pChOtlFRRxLFYtgobQVWnUwufQLmrQkKS6OgmvBwY/FqoOLs64OroIg+AHi7OCk6CIl/i8ptIjx4Lgf7+497t4BQqvKNLMvBmi6ZaQTcSmXX5UCr/BjBEGICMvMrCczi1l4jq97+Ph6F+VZ3uf+HINqwWSATyKOsbphEW8Qz25adc77xCIryyrxOfGkQRckfuS64vIb55LDAs8UjWx6nlgklko9rPQwKxsa8QxxRNV0yhdyLquctzhr1Qbr3JO/MFTQVzJcpzmGBJaQRAoSFDRQQRUWorTqpJhI037cwz/q+FPkUshVASPHAmrQIDt+8D/43a1ZnJ5yk0JxoP/Ftj/GgcAu0G7a9vexbbdPAP8zcKV3/bUWMPdJerOrRY6A8DZwcd3VlD3gcgcYfqrLhuxIfppCsQi8n9E35YGhWyC45vbW2cfpA5ClrpZvgINDYKJE2ese7x7o7e3fM53+fgB0X3Knjh7uUgAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+gDGQofAnKxu+4AAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAWGUlEQVR42u3de5DVdeH/8dcKppSLiCPqCJWXQFzHC4XEgHgL8NKAgZoDNSRqeUmdZgyvTVECNQGCOqICIZI4Q8KW0pguKg4xIGlcUiQQb3lBgUXBAHXZz++PvuzPdRcEdgHFx2OGGeZ8Pp/z/pzP5TzP55yzuyVFURQBgO20l00AgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIAAICAAICAACAoCAACAgAAgIAAgIAAICgIAAICAACAgACAgAAgKAgAAgIAAICAAICAACAoCAACAgAAgIAAgIAAICgIAAICAACAgACAgAAgKAgAAgIAAICAAICAACAoCAACAgAAgIAAgIAAICgIAAICAAICAACAgAAgKAgAAgIAAgIAAICAACAoCAACAgACAgAAgIAAICgIAAICAAICAACAgAAgKAgAAgIAAgIAAICAACAoCAACAgACAgAAgIAAICgIAAICAAICAACAgAAgKAgACAgAAgIAAICAACAoCAAICAACAgAAgIAAICgIAAgIAAICB8prVp0yYlJSX597//bWM0kvvuuy8lJSWZMGGCjcHnLyAvvPBCSkpK6v139dVX26Jsk8svvzwlJSUZPXq0jYFjwhUIAF8kTbd3gfbt26coiiRJ165dM3v27MycOTOnnHKKrck2GzNmTMaMGWND4JhwBQKAgADA7g7IXXfdtcUP3D/+r0ePHkmSDRs2pKysLCUlJXn66ae3et8PP/zwVj+4f/XVVzNu3Lj0798/ZWVl6dOnT0aPHp3Fixc3yrrurG2w2ZtvvpkHH3wwQ4cOzU9+8pN07tw5ZWVl6d+/f2677bYsXLiw5q3ETxoxYkRKSkoyffr0JMlLL72U22+/PWeeeWYOPvjg3HHHHQ0eY7MVK1bk3nvvzfe///0cf/zx+fGPf5yxY8fmxRdf3Opyo0ePTklJSaZNm7ZDx9bHH2NRFPnXv/6VESNG5Oyzz843v/nNDBo0KHPmzNni8o21fYuiyLPPPptbbrklZ5xxRrp165bBgwdn0aJFO2XsT/P666+nc+fOKSkpyfjx4+u9nzVr1mTq1Km58sorc9JJJ6Vbt2658cYb89RTT6WqqmqHz/eG7pPP8zHxhVU0QJcuXYokxcyZM+udPmbMmCLJp/7r3r17zTJjx44tkhQ333zzFsfdtGlTcf755xdJilmzZtWZ/tBDD211vLvvvrv46KOPGryu22JH7/fRRx/91GVGjx5dbNq0qc6Yw4cPL5IUU6ZMKe699946y91yyy0NHqMoimLWrFlFaWnpp97HkiVL6iw7atSoIkkxderUHTr2Nj/GsWPHFoMHD97i2H/605/qXb4xtu/o0aOLG2+8cYvLl5eXN/rYEydOLJIUf/jDH+pMW7FiRdG9e/ciSXHXXXfVu/wzzzxTtG3bdovjDho0qFi/fv1u2Sef52Pii2qnBmRrXnjhhZqd8te//rXm9uXLl9fc/s4779S77NKlS4skRdu2besc7LNnz651AldWVhZVVVXF2rVri5kzZ9acPFOmTGnwujbU1u738ccfL0aNGlU888wzxerVq4uqqqriww8/LFauXFmUl5fXLDdv3rwtnkhJii5duhQVFRVFZWVlUV1d3WhjPP/88zXTx44dW6xYsaKoqqoqNmzYULzxxhvF9OnTa+KyMwOSpOjZs2fx+OOP1+zrd999t5gwYcJWj6PG2r4DBgwo5syZU7z77rtFVVVVsWrVqpoXQUmKZcuWNerYWwrIqlWrit69exdJijvuuKOoqqra6vE2fvz4WvvsueeeKy644IKaF1i7Y598no8JAdmFAVm1alVx8sknF0mKkSNH1npiq66uLgYOHFgkKR566KF6l7/nnnuKJMW4ceNq3b5x48bi1FNPLZIUjzzySL3LLliwoOZAWLlyZYPWtSEaer/jxo0rkhS33nrrFk+kn//858W77767w+u4pTGqqqqKH/7wh1t8JbxZ69atd3pABg8eXPz3v/+tM/2jjz4qevbsWSQpnnjiiUZ77B8f+9Zbby0+/PDDOtOrq6uLm2++uUhSDB8+vFHHri8ga9asKfr161ckKUaNGlVvPKqqqmrmmTRpUr3jvvbaazXnxurVq3f5Pvk8HxNfVLv8Q/QPP/wwv/rVrzJr1qxceumlNT88tFlJSUn69euXJJkwYUKqq6trLb9hw4aMGjUqSXL66afXmrZkyZLMnDkzHTp0qDNts+OPPz6XX355kmTevHkNWtedtQ22Rfv27Ws+69mSbt26Zf/999/h9dzSGMuXL8+kSZNSWlqaPn367Na3YDt06JAvf/nLdW5v2rRpzTHw9ttvN9pj/7ijjjoqe++9d53bS0pK0rt37yTJnXfeud2fK2zL2Ju9//77GTRoUCZPnpzhw4fnyiuvTJMmTerMt2zZskyePDkdO3bM+eefX+99tWnTJr/4xS9qzqXP2j75PBwTXzRNd/WA48ePzx133JFvf/vbGTJkSPbdd98685x00klp1apVysvLs2zZsrRr165m2sKFC7N48eJcfPHFOfzww+s8sSVJ796986UvfWmrT6xjxozJc889l7PPPrtB67qztsHHP9hbsmRJXnnllbz11lt555138p///Cf/+Mc/kiQbN25s8Pps7xjLli1Lklx00UUNCtTO1qJFi0/dRjtr+7Zu3brmCwxr1qzJQQcd1Ohjb9iwITfddFPGjh2b3/72t7nmmmvStGn9p/TSpUuTJOedd1722WefLd5n27ZtkyRvvPHGbtsne+oxISAN9Pjjj+eKK65IkowbN67ekypJSktLc9NNN+Waa67JE088USsgDz30UJKkf//+dZarrKxMkhxyyCFbXY+WLVsmSd56660Gr+vO2gZvv/12Ro8enWHDhu20/bGjY6xatSpJcsQRR3ymD+7NYa7vmzM7e/s2a9as5v+ffMJpjLHXrVuX3/zmN7nttttyzDHH5Morr9xiPD6+z6677rpcd91123Rls6v3yZ5+TOyJdtlbWC+++GK+973vJUmmT5+esrKyrc7fvXv3JMnw4cOzfv36JMnKlSszbNiwtG7dOh07dvzMrGtj3+/atWszYMCADBs2LMcdd1wmTZqU+fPn57XXXktlZWU2bNiw1a8jbouGjLH5LZmtPWF9lu2K7fvxt14//pZSY419zTXX1JwLixcvzpgxY7Jp06ZtWp9tsbX72hPtimPCFcgOWrNmTa644oqsW7cuw4cP3+rbRpu1a9cuffv2zdSpUzN//vx06dIlc+fOTZLccMMN2W+//XboyiJJVq9enSQ59NBDG2VdG3sbzJ49O48++mg6duyYhx9+OAcffHCdeRr6WUxDxmjevHmtV7WfN7ti+7733nu1rqh3xtgVFRVp06ZNunXrlkGDBqVly5YZOHBgvcsfcMABSZKxY8fmkksu8cy3G44JVyA74KOPPsott9ySioqKXHzxxbniiiu2aUfstddeueiii5Ik06ZNS3V1dSZOnFjr6uSTjjzyyJr5t/Y+5cyZM5Mkxx57bKOsa2Nvg80f0g0YMKDeA7kxNGSMNm3a1DyBfR5fqe6K7fvCCy8kSQYOHFgrII019u23357vfOc7adeuXc0PjF5yySX585//XO/8Rx11VJLkqaee8sNwu+mYEJAdcN9992XkyJHp2LFjhg4dWuu94U/TuXPnJMnIkSMzY8aMTJ06Nf369as5GT7p6KOPzsknn5xFixaloqKi3nnmz5+fe+65J0nqvA3WkHVtzG2w+Zs9m6+U6ns74pVXXmnQOjVkjKOPPjqlpaWZPXt2FixYUO88b7zxRq1X4Z8lO3v7rl27NrfeemuSup/VNdbYX/nKV2r+37Fjxzz66KNJkj59+tS8QPrkPjvrrLPyxz/+cYvnxsfPkYULF36hngh3xTknINtp1qxZNZfL48ePT6tWrbZr+ZYtW2bIkCFJ/vftkc2vELb06n2fffbJ0KFDkyS9evXKtGnTUllZmerq6qxbty5PPvlkLrzwwiTJAw88UOsD7Iaua2Nugw4dOiRJfvnLX+Zvf/tb1q5dm02bNuX999/PggULctVVV9U8jh3VkDFatGiRkSNHJkl++tOf5plnnsnGjRtTVVWVN998M/fff3/at2+fdevWfSYP+sbavo899ljmz5+f9957L1VVVfnggw/y/PPP5+qrr05FRUUuu+yydO3adZfs2x49euT+++9Pkpx22mmZP39+nXNj87nUs2fPjBgxIi+++GLWrVuXTZs25b333suzzz6bm266KR06dMiHH374hXoi3BXnnICk9h+Umj17dpLk1FNPrff3Uk2ePLnm/8cdd9xWfxfUmjVr6h3vnHPOSfK/b52UlpamU6dOW12/rl27pry8PEnSt2/fHHjggWnSpEmaN2+e008/PUuXLs2dd95ZE6TGXNf67Mj9nnDCCTU/63LWWWdl//33T9OmTVNaWpoTTzwxlZWVufvuuxu04xs6Rv/+/XP11Vdn7ty56dixY5o1a5a99947hx12WH7wgx9kzJgxjRbhxtZY2/f2229Phw4d0qJFi+y9997Zd999c+yxx2bixIn50Y9+lCFDhtT5OvnO3LcXXnhhbrvttpoXUJu/br3ZiSeemLlz5+aYY47Jtddem2984xtp3rx5mjZtmhYtWuRb3/pWhg4dmtatW9e6wvki2BXn3J7oM/81mrKysnTv3j0VFRUZPHjwNv3cwbnnnpuXX345FRUVmTFjRhYsWJB27drltNNOS48ePRrtW1U7S0lJSa666qqccMIJefDBB/PYY4+lffv2NT8g2alTp/zzn//crWM0a9Ysv//979OzZ8/85S9/yd///ve0a9cuPXv2zJlnnpmvfe1ruf766/fo7Tt58uS0adMmFRUVWbhwYV5++eWcccYZOfvss9OtW7d6fxZpZ+7bvfbaK5dddllWrVqVX//61+nfv3/Ky8tz2GGH1czTqVOnzJkzJ7Nnz86cOXMyb968PP/88zn++OPTpUuXdOnSJR06dKj3Syp7sl1xzu2R263wiRpslxEjRuTaa6/Nww8/nO9+97s2CN7CAgABAUBAABAQAPYgPkQHwBUIAAICgIAAICAAICAACAgAArI1o0ePTklJSaZNm2bPAQhI49mwYUPNr0afMWOGvQsgIAB81jTdkx5Ms2bN/L1nAFcgAAgIAF/sgGzYsCFlZWUpKSnJ008/vdV5H3744Xr/Tvpmr776asaNG5f+/funrKwsffr0yejRo7N48eLtfhCDBw+u8/fFFy1atMX5G3NsgC+q7foMpFmzZvnZz36WSy+9NNOnT0+nTp3qna+6ujqTJk1KklxwwQX1xqVXr161blu8eHHKy8uTJHfffXcGDhyYpk0b/yOa3Tk2wB6l2E7Lly8vkhRJinfeeafeeZYuXVokKdq2bVusX7++1rTZs2fXLF9eXl5UVlYWVVVVxdq1a4uZM2cWbdu2LZIUU6ZMqXO/o0aNKpIUU6dO3eL6de/evUhSLFy4sM60howNQG3b/RnI4YcfnoEDByZJ5s6dW+88M2fOTJIMGjQozZo1q7n9gw8+yE033ZQkeeSRR3LuuefmgAMOSJMmTVJaWppTTjklU6ZMqblyWbVqVaOFcneODbAn2u6AlJSUpF+/fkmSCRMmpLq6utb0DRs2ZNSoUUmS008/vda0JUuWZObMmenQoUOdaZsdf/zxufzyy5Mk8+bNa7QHujvHBhCQ/3PSSSelVatWKS8vz7Jly2pNW7hwYRYvXpyLL744hx9+eK1py5cvT5L07t07X/rSl7Z4/926dUuSPPfcc432QHfn2AAC8n9KS0tr3g564oknak176KGHkiT9+/evs1xlZWWS5JBDDtnq/bds2TJJ8tZbbzXaA92dYwMIyMd07949STJ8+PCsX78+SbJy5coMGzYsrVu3TseOHW1dAAGpq127dunbt29eeumlzJ8/P8n//1D9hhtuyH777bfDr+5Xr16dJDn00EMb7YHuzrEBBOTjC+61Vy666KIkybRp01JdXZ2JEyfWujr5pCOPPLJm/o0bN27xvjd/i+vYY49ttAe6O8cGEJBP6Ny5c5Jk5MiRmTFjRqZOnZp+/frlqKOOqnf+o48+OieffHIWLVqUioqKeueZP39+7rnnniRp1LfBdufYAALyCS1btsyQIUOSJOedd16SZMCAASkpKal3/n322SdDhw5NkvTq1SvTpk1LZWVlqqurs27dujz55JO58MILkyQPPPBADjrooEZ7oLtzbAABqcc555yTJFm3bl1KS0u3+OtNNuvatWvNrw3p27dvDjzwwDRp0iTNmzfP6aefnqVLl+bOO++sCVJj2p1jA+xpGvwLn8rKytK9e/dUVFRk8ODB2X///T91mXPPPTcvv/xyKioqMmPGjCxYsCDt2rXLaaedlh49eqSsrGyH1+ejjz7abWMDfJGUFHvQX2AqiiJf/epX8/rrr2fx4sVp3769PQywk+xRfw9kxYoVef3115Nkm66EANhxe8TvLC+KImvWrMm9996b5H+/DPHTfuIcgIb5XL+F9bvf/S7XX399rdtatWqVJ554wmcZAK5AtuyII47I+eefn2effTaHHXZYevXqlfPOOy9f//rX7VkAVyAAfBbtZRMAICAACAgAAgKAgACAgAAgIAAICAACAoCAAICAACAgAAgIAAICgIAAgIAAICAACAgAAgKAgACAgAAgIAAICAACAoCAAICAACAgAAgIAAICgIAAgIAAICAACAgAAgKAgACAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgACAgAAgKAgAAgIAAICAAICAACAoCAACAgAAgIAAgIAAICgIAAICAACAgACAgAAgKAgAAgIAAICAAICAACAoCAACAgAAgIAAgIAAICgIAAICAACAgACAgAAgKAgAAgIAAgIAAICAACAoCAACAgACAgAAgIAAICgIAAICAAICAACAgAAgKAgAAgIAAgIAAICAACAoCAACAgACAgAAgIAAICgIAAICAAICAACAgAAgKAgAAgIAAgIAAICAACAoCAACAgACAgAAgIAAICgIAAgIAAICAACAgAAgKAgACAgAAgIAAICAACAoCAAICAACAgAAgIAAICgIAAgIAAICAACAgAAgKAgACAgAAgIAAICAACAoCAAICAACAgAAgIAAICgIAAgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIADsMf4fm0P6dsHmfGQAAAAASUVORK5CYII=';
				}
								
				myResolve(image);
			});
						
		});
		
		return promise;
	}
	
	
	/*
	***	M1 - Builds OL map
	*		@step - one (blue), or two (red and blue) locations
	*/	
	buildMap(coordinates, step){
		var that = this;
		
		var map2 = new Map({
			controls: defaultControls().extend([
				new FullScreen({
				  source: 'fullscreen'
				})
			  ]),
			  target: this.newTarget(step),
			  view: new View({
					center: coordinates,
					zoom: that.zoom[that.map_type],
				})
			});
		
		//append background layer
		//map2.addLayer(this.getLayer());
		map2.getLayers().extend(this.getLayer());
		
		// create location points		
		const vectorSource = new VectorSource();
		vectorSource.addFeature(this.locationPoint(coordinates,step));
		const vectorLayer = new VectorLayer({
		  source: vectorSource,
		});
		
		map2.addLayer(vectorLayer);
		
		this.olMap.push(map2);
		
		return map2;
	}
	
	/*
	***	M1.0.1 - Builds OL map with both locations
	*		@step - one (blue), or two (red and blue) locations
	*/	
	buildMap2(coordinates){
		var that = this;
		
		var center_x = (coordinates[0][0] + coordinates[1][0]) / 2;
		var center_y = (coordinates[0][1] + coordinates[1][1]) / 2;
				
		var map3 = new Map({
			controls: defaultControls().extend([
				new FullScreen({
				  source: 'fullscreen'
				})
			  ]),
			  target: this.newTarget(3),
			  view: new View({
					center: [center_x,center_y],
					zoom: that.zoom[that.map_type],
				})
			});
						
		var new_ext = [coordinates[0][0] - 1.5 * Math.abs(coordinates[0][0] - coordinates[1][0]),
						coordinates[0][1] - 1.5 * Math.abs(coordinates[0][1] - coordinates[1][1]),
						coordinates[1][0] + 1.5 * Math.abs(coordinates[0][0] - coordinates[1][0]),
						coordinates[1][1] + 1.5 * Math.abs(coordinates[0][1] - coordinates[1][1])];
				
		map3.getView().fit(new_ext);
		
		
		//append background layer
		//map2.addLayer(this.getLayer());
		map3.getLayers().extend(this.getLayer());
		
		// create location points		
		const vectorSource = new VectorSource();
		//add both points on map
		vectorSource.addFeature(this.locationPoint(coordinates[0],0));
		vectorSource.addFeature(this.locationPoint(coordinates[1],1));
		
		const vectorLayer = new VectorLayer({
		  source: vectorSource,
		});
		
		map3.addLayer(vectorLayer);
		
		this.olMap.push(map3);
		
		return map3;
	}
	
	
	/*
	***	M1.1 - Creates location point
	*		@step - first (blue) or second (red) location
	*/	
	locationPoint(coordinates, step){
		// define styles
		var pointStyles = [{	//blue
								fill: new Fill({
								  color: 'rgba(255, 255, 0, 0.2)'
								}),
								stroke: new Stroke({
								  color: '#0000cc',
								  width: 2
								}),
								image: new CircleStyle({
								  radius: 7,
								  fill: new Fill({
									color: '#3399ff'
								  })
								})
							},{	//red				
								fill: new Fill({
								  color: 'rgba(255, 0, 255, 0.2)'
								}),
								stroke: new Stroke({
								  color: '#ff0000',
								  width: 2
								}),						
								image: new CircleStyle({
								  radius: 7,
								  fill: new Fill({
									color: '#ff0000'
								  })
								})
							}];
							
		var oFeature = new Feature(new Point(coordinates));	
		oFeature.setStyle(new Style(pointStyles[step]));	
		
		return oFeature;	
	}
	
	/*
	***	M1.2 - Creates background layer
	*/
	getLayer(){
		
		// TODO - copy layers from existing OL map
		var that = this;
		
		if(this.map_type == 'OSM'){
			var layer =  new TileLayer({
						title: 'OpenStreetMap',
						source: new OSM(),
						visible:true,
			});
			
			return [layer];
		}
		else if(this.map_type == 'DOF'){
			var layer1 = new TileLayer({
			  visible: true,
			  title: "SI - Orthophoto, 0,5m",
			  source: new TileWMS({
				url: "https://storitve.eprostor.gov.si/ows-pub-wms/SI.GURS.ZPDZ/wms",
				crossOrigin: "Anonymous",
				params: {
				  'layers': 'DOF5',
				},
				projection: 'EPSG:3794',
			  })
			});
			
			//italian dof
			const layer2 = new TileLayer({
			  visible: true,
			  title: "IT - Orthophoto",
			  source: new TileWMS({
				url: "https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=5&map=/ms_ogc/WMS_v1.3/raster/ortofoto_colore_12.map",
				crossOrigin: "Anonymous",
				params: {
				  'layers': 'OI.ORTOIMMAGINI.2012.33',
				},
				projection: 'EPSG:4326',
			  }),
			  minZoom: 15,
			});
			
			// satellite data
			let layer3 = new TileLayer({
				visible: true,
				title: "satellite",
				source: new TileWMS({
					url: "https://services.sentinel-hub.com/ogc/wms/9fad3ba1-fed2-4b9b-b6ea-354b6d765c23",
					crossOrigin: "Anonymous",
					params:{layers:"TRUE_COLOR",
							maxZoom:16,
							maxcc:70,
							minZoom:6,
							preset:"TRUE_COLOR",
							time:"2024-08-27",
							urlProcessingApi:"https://services.sentinel-hub.com/ogc/wms/9fad3ba1-fed2-4b9b-b6ea-354b6d765c23"
					},
					serverType: 'geoserver',
					transition: 0
				}),
			});
			
			return [layer3,layer2,layer1];
		}
	}
	
	/*
	***	M1.3 - Creates HTML DOM elements for hidden map
	*/
	newTarget(step){
		var that = this;
		//element id
		var eid = this.map_type + "_" + step;
		
		this.mapDomId.push(eid);
		
		//create dom element
		$("#"+this.map_container).append($("<div id='"+eid+"'></div>"));
		
		$("#"+eid).css("width", this.map_size[0])
								.css("height",this.map_size[1])
								.css("position","fixed")
								.css("top",0)
								.css("left",0)
								.css("z-index",10001)
								.css("background","white");
								
		return eid;						
	}
	
	/*
	***	M3 - destroy ol maps
	*/
	destroy(){
		// destroy map
		for(var i=0;i<this.olMap.length;i++){
			this.olMap[i].setTarget(null);
			this.olMap[i] = null;
			
			$("#"+this.mapDomId[i]).remove();	// uniči div element karte
		}
		
		
	}
	
}